var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[(_vm.showPDF)?_c('iframe',{staticClass:"iframe-custom",attrs:{"src":_vm.src,"title":_vm.name,"frameborder":"0","scrolling":"no","allowfullscreen":""}}):_c('v-progress-linear',{attrs:{"color":"blue darken-2 accent-4","indeterminate":"","rounded":"","height":"6"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }